<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="surveyForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="first_name" class="text-black-1">Name</label>
        </div>
        <div class="input-group col-8">
          <input
            id="name"
            class="form-control rb-input"
            placeholder="Please enter survey name."
            formControlName="name"
            name="name"
            type="text"
          />
          <div class="col-12 error-mssg" *ngIf="(formControl.name.touched || submitted) && formControl.name.errors">
            <label for="name" class="text-danger" *ngIf="formControl.name.errors.required">*Name is required.</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="description" class="text-black-1">Description</label>
        </div>
        <div class="input-group col-8">
          <textarea
            id="description"
            class="form-control rb-input"
            placeholder="Add survey description."
            formControlName="description"
            name="description"
            type="text"
          >
          </textarea>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.description.touched || submitted) && formControl.description.errors"
          >
            <label for="description" class="text-danger" *ngIf="formControl.description.errors.required"
              >*Description is required.</label
            >
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label for="isactive" class="text-black-1" translate>Survey status</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="surveyStatus"
            optionLabel="name"
            optionValue="value"
            formControlName="isActive"
            placeholder="Select survey status."
          ></p-dropdown>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.isActive.touched || submitted) && formControl.isActive.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="formControl.isActive.errors.required">
              *Please select survey status.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate>User groups</label>
        </div>
        <div class="col-8">
          <fui-multi-select
            [style]="{ width: '100%' }"
            class="selection"
            formControlName="groupIds"
            [options]="userGroupsOptins"
            labelField="name"
            valueField="uuid"
            [isSearchable]="true"
            [showCountText]="'Select'"
            #multiSelect
          >
            <fui-select-option *ngFor="let option of multiSelect.filteredOptions" [value]="option"> </fui-select-option>
          </fui-multi-select>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.groupIds.touched || submitted) && formControl.groupIds.errors"
          >
            <label for="isactive" class="text-danger" *ngIf="formControl.groupIds.errors.required">
              *Please select user group.
            </label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate>Pre-requisites</label>
        </div>
        <div class="col-8">
          <fui-multi-select
            [style]="{ width: '100%' }"
            class="selection"
            formControlName="surveyIds"
            [options]="surveys_data"
            labelField="name"
            valueField="uuid"
            [isSearchable]="true"
            [showCountText]="'Select'"
            #multiSelectSurvey
          >
            <fui-select-option *ngFor="let option of multiSelectSurvey.filteredOptions" [value]="option">
            </fui-select-option>
          </fui-multi-select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label class="text-black-1" translate>Reminder Email template</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="emailTemplate"
            optionLabel="templateName"
            optionValue="uuid"
            formControlName="emailTemplateId"
            placeholder="Select Email template."
          ></p-dropdown>
          <div
            class="col-12 error-mssg"
            *ngIf="(formControl.emailTemplateId.touched || submitted) && formControl.emailTemplateId.errors"
          >
            <label class="text-danger" *ngIf="formControl.emailTemplateId.errors.required">
              *Please select email template .
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
